import { concatIf } from '@btime/helpers'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import {
  useOpenEditFieldsModal,
  useOpenExportHistoryModal,
  useOpenExportModal,
  useOpenImportHistoryModal,
  useOpenTemplatesModal
} from '../../../utils/routes/modals/modalsActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import IconText from '../../../components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const openEditFieldsModal = useOpenEditFieldsModal()
  const openImportHistoryModal = useOpenImportHistoryModal()
  const openExportHistoryModal = useOpenExportHistoryModal()
  const openTemplatesModal = useOpenTemplatesModal()
  const openExportModal = useOpenExportModal()

  const { t } = useTranslation(['common', 'listIntegrations'])
  const navigate = useNavigation()

  const isOwner = useIsOwner()
  const canEdit = useSessionPermission('editIntegration')
  const canExport = useSessionPermission('exportIntegration')
  const canImport = useSessionPermission('importIntegration') && false
  const canSetup = useSessionPermission('setupIntegration')
  const canListTemplate = useSessionPermission('listTemplate')

  const filter = useCleanFilterForRequest()

  const options = [
    //   ...concatIf(canImport, [
    //     {
    //       value: 'import',
    //       iconLeft: 'RiUploadCloud2Line',
    //       onClick: () => navigate(`/import/v2/integration`)
    //     },
    //     {
    //       value: 'importHistory',
    //       iconLeft: 'RiTimeLine',
    //       onClick: () => openImportHistoryModal('integration')
    //     },
    //     { line: true }
    //   ]),
    //   ...concatIf(canExport, [
    //     {
    //       value: 'export',
    //       iconLeft: 'RiDownloadCloud2Line',
    //       onClick: () => openExportModal({ entity: 'integration', filter })
    //     },
    //     {
    //       value: 'exportHistory',
    //       iconLeft: 'RiTimeLine',
    //       onClick: () => openExportHistoryModal('integration')
    //     },
    //     { line: true }
    //   ]),
    //   ...concatIf(canListTemplate, [
    //     {
    //       value: 'templates',
    //       iconLeft: 'RiFileCopy2Line',
    //       onClick: () => openTemplatesModal('integration')
    //     },
    //     { line: true }
    //   ]),
    //   ...concatIf(canSetup, [
    //     {
    //       value: 'fields',
    //       iconLeft: 'RiListSettingsLine',
    //       onClick: () => openEditFieldsModal('contracts')
    //     }
    //   ])
    // ...concatIf(canSetup, [
    //   {
    //     value: 'group',
    //     iconLeft: 'RiListSettingsLine',
    //     onClick: () => navigate('/groups')
    //   }
    // ])
  ]

  return (
    <Fragment>
      <Grid justify="space-between" align="center" gutter={0.4}>
        <Col>
          <Title size="h2" color="dark3" noWrap>
            {t('listIntegrations:title')}
          </Title>
        </Col>
        <Col flex={1} />
        {!!options.length && (
          <Col>
            <DropdownLink
              fromRight
              t={key => t(`listIntegrations:menu.${key}`)}
              options={options}
              actionContent={
                <IconText label={t('moreOptions')} iconName="BsThreeDotsVertical" noWrap size="small" bold />
              }
            />
          </Col>
        )}
      </Grid>

      <Separator weight={2} />
    </Fragment>
  )
}

export default PageHeader
